export default __webpack_public_path__ + "static/media/hostfully_step19.3273fb72.png";